import React from "react";
import api from "utils/api";
import "./Others.scss";
import Loader from "Components/Loader";
import { Empty, Collapse, Upload} from "antd";
const { Panel } = Collapse;
import utils from "../../utils";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resultObjects: [],
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    api
      .get_custom_doc_summary_list({
        patient_id: this.props.data?.patient_id,
      })
      .then((res) => {
        this.setState({
          resultObjects: res.data?.data?.results || [],
          isLoading: false,
        });
      })
      .catch((err) => {});
  }

  previewDoc(url)
  {
    utils.Modal(true, {
      width: "1023px",
      content:
      <div style={{height:"75vh"}} className="finish-Consult-Modal">
      <div className="finish-header">Preview Document</div>
      <div style={{height:"65vh",overflow:"auto",display:"flex",justifyContent:"center"}} className="finish-wrapper">
        {url.includes("pdf")?
         <object height="550" width="800" data={url}></object>:
         <object height="550" data={url}></object>} 
      </div>
  </div>
    })
  }

  render() {
    const viewProps = {
      showUploadList: { showPreviewIcon: true,showRemoveIcon:false },
      onPreview:file =>{
          this.previewDoc(file.url+"#toolbar=0&scrollbar=0")
      },
  };
    return (
      <>
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <div className="mhe-wrapper-container">
            <div className="mhe-header">
              <div>Documents Upload</div>
            </div>
            <div className="mhe-content"> 
            {this.state.resultObjects.length == 0 ? (
              <Empty
                description={"No Data"}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              <>
              {this.state?.resultObjects.map((types)=>{                
                return(
                  <Collapse
                  style={{ overflowY: "auto" }}
                  bordered={false}
                  expandIconPosition="start"
                  ghost={true}
                  className="mhe-list-container" >
                  <Panel  header={types.value}>
                      <>
                      {types?.Date.map((dates)=>{
                        let imageFile = [];
                          for(let i of dates?.files){
                            for(const [a,b] of Object.entries(i)){
                                imageFile.push({url:b, key:a})
                            }
                            }
                    return(
                            <Collapse
                              style={{ overflowY: "auto" }}
                              bordered={false}
                              expandIconPosition="start"
                              ghost={true}
                              className="mhe-list-container">
                              <Panel header={<div style={{display:"flex",justifyContent:"space-between"}}><div>{utils.FormatDate(dates?.date, "DATE_14")}, {utils.FormatDate(dates?.date, "TIME_1")}</div><div>{utils.FirstNameLastName(utils.salutationPrefixName(dates?.doctor_salutation, utils.getDisplayName(dates?.doctor_name, dates?.doctor_last_name)), "250px")}</div></div>} >
                                {imageFile.length>0?
                                <Upload fileList={imageFile}  {...viewProps} listType="picture-card"></Upload>:
                                <Empty
                                description={"No Data"}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />}
                              </Panel>
                              </Collapse>                       
                          )
                      })}
                      </>
                  </Panel>               
                </Collapse>
                )
              })}
              </>
            )}
            </div>
            
          </div>
        )}
      </>
    );
  }
}
